const $priceDom = $('#sp_price1')
const $cPriceDom = $('#sp_price2')
const $offPriceDom = $('.price-group .sp-p span')
const $numDom = $('#calcNumber')

const productData = window.product || []

/** 获取当前选中的变量 */
function getCur() {
    const opts = {
        option1: $('#sp-opt-group1 div.active').attr('data-val'),
        option2: $('#sp-opt-group2 div.active').attr('data-val'),
        option3: $('#sp-opt-group3 div.active').attr('data-val'),
    }

    return productData.find(item => {
        return (
            (!opts.option1 || item.option1 == opts.option1) &&
            (!opts.option2 || item.option2 == opts.option2) &&
            (!opts.option3 || item.option3 == opts.option3)
        )
    })
}

/** 更新价格显示 */
function changePrice() {
    const curVariant = getCur()
    if (!curVariant) return

    const num = parseInt($numDom.val()) || 1

    // 识别当前页面使用的小数点符号
    const currentText = $priceDom.text().trim()
    const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/)

    const decimalSeparator = decimalMatch ? decimalMatch[1] : '.'
    const decimalLength = decimalMatch ? decimalMatch[2].length : 0

    // 格式化输出
    const formatValue = cents => {
        let val = ((cents * num) / 100).toFixed(decimalLength)
        if (decimalSeparator === ',') {
            val = val.replace('.', ',')
        }
        return val
    }

    const price = formatValue(curVariant.price)
    const compare = formatValue(curVariant.compare_at_price)

    // 计算折扣
    let offPercent = 0
    if (curVariant.compare_at_price > curVariant.price) {
        offPercent =
            100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100)
    }

    const priceRegex = /\d+(?:[.,]\d+)*/
    const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g

    const updateHTML = ($el, regex, value) => {
        if ($el && $el.length) {
            const text = $el[0].textContent.trim()
            const newHtml = text.replace(regex, value)
            if ($el.html() !== newHtml) {
                $el.html(newHtml)
            }
        }
    }

    updateHTML($priceDom, priceRegex, price)
    updateHTML($cPriceDom, priceRegex, compare)
    updateHTML($offPriceDom, offRegex, offPercent)
}

// 绑定选项点击事件
$(document).on('click', '.sp-option', function () {
    setTimeout(changePrice, 10)
})

$('.sp_buy_now').click(function () {
    let num = $numDom.val()
    let id = getCur().id
    window.location.href = '/cart/' + id + ':' + num
})

document.addEventListener('DOMContentLoaded', function () {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
        let nowTime = new Date()
        let endTime = new Date(endTimeG)

        let leftTime = endTime.getTime() - nowTime.getTime()
        if (leftTime < 0) {
            setupNewCountdown()
            leftTime = 0
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60)
        leftH = leftH >= 10 ? leftH : '0' + leftH
        leftM = leftM >= 10 ? leftM : '0' + leftM
        leftS = leftS >= 10 ? leftS : '0' + leftS

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        }
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9)
        const currentTime = new Date()
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }
    let intervalId

    function getCutDownTime() {
        setupNewCountdown()
        if (intervalId) clearInterval(intervalId)
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime()
            $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
            $('.sp_top_cut_down .sp_left_view .sp_minute').html(
                cutDownTimeText.minute
            )
            $('.sp_top_cut_down .sp_left_view .sp_second').html(
                cutDownTimeText.second
            )
        }, 1000)
    }

    getCutDownTime()

    new WOW().init()

    jQuery('.sp-scroll').slide({
        mainCell: '.nav-imgs',
        autoPlay: true,
        effect: 'leftMarquee',
        interTime: 12,
        vis: 1,
        scroll: 1,
    })

    new Swiper('.mySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 35,
        loop: true, //循环滚动
        freeMode: true,
        speed: 6500, //匀速时间
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: true,
        },
        allowTouchMove: false,
    })

    new Swiper('.sp-swiper1', {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
    })

    document
        .querySelectorAll('.sp-part6 .sp-swiper2')
        .forEach(function (swiperEl) {
            const part = swiperEl.closest('.sp-part6')
            const tabItems = part ? part.querySelectorAll('.sp-font .sp-item') : []
            const isPcPart = part && part.classList.contains('sp-pc')

            function syncTabs(sw) {
                const idx = sw.realIndex
                tabItems.forEach(function (item, i) {
                    item.classList.toggle('active', i === idx)
                })
            }

            const swiper = new Swiper(swiperEl, {
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                loop: true,
                on: {
                    slideChange: function () {
                        syncTabs(this)
                    },
                },
                ...(isPcPart
                    ? {
                        effect: 'fade',
                        fadeEffect: { crossFade: true },
                        slidesPerView: 1,
                        speed: 500,
                    }
                    : {
                        slideShadows: true,
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        centeredSlides: true,
                    }),
            })

            syncTabs(swiper)

            tabItems.forEach(function (item, index) {
                item.addEventListener('click', function () {
                    swiper.slideToLoop(index)
                })
            })
        })

    new Swiper('.sp-swiper2-m', {
        watchSlidesProgress: !0,
        slidesPerView: 'auto',
        centeredSlides: !0,
        spaceBetween: -30,
        loop: !0,
        loopedSlides: 5,
        slidesPerGroup: 1,
        grabCursor: !0,
        autoplay: {
            delay: 3e3,
            stopOnLastSlide: !1,
            disableOnInteraction: !1,
        },
        speed: 500,
        on: {
            progress: function (swiper, progress) {
                for (i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i),
                        slideProgress = this.slides[i].progress
                    let translateZ = 0
                    translateZ = -20 * Math.abs(slideProgress)
                    let translateX = 0
                    translateX = -30 * slideProgress * (Math.abs(slideProgress) + 1)
                    let rotateY = 0
                        ; (rotateY = 25 * slideProgress),
                            slide.transform(
                                'translateX(' +
                                translateX +
                                'px) translateZ(' +
                                translateZ +
                                'px) rotateY(' +
                                rotateY +
                                'deg)   '
                            )
                }
            },
            setTransition: function (swiper, transition) {
                for (var i2 = 0; i2 < this.slides.length; i2++) {
                    var slide = this.slides.eq(i2)
                    slide.transition(transition)
                }
            },
        },
    })

    new Swiper('.sp-swiper3', {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        initialSlide: 1,
        pagination: {
            el: '.sp-pagination3',
            clickable: true,
        },
        navigation: {
            nextEl: '.sp-swiper-btn-next',
            prevEl: '.sp-swiper-btn-prev',
        },
    })

    new Swiper('.sp-swiper4', {
        speed: 9000,
        autoplay: true,
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
    })

    new Swiper('.sp-swiper-fade', {
        spaceBetween: 10,
        effect: 'fade',
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    })

    new Swiper('.sp-swiper-fade1', {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
        on: {
            slideChange: function (e) {
                e.slides.find('.sp-text').each(function () {
                    this.style.animation = 'none'
                })
                const spText = e.slides.eq(e.activeIndex).find('.sp-text')[0]
                if (spText) {
                    spText.style.animation = 'none'

                    spText.style.animation = `swiper-up-fade 0.5s ease forwards`
                }
            },
        },
    })

    new Swiper('.sp-swiper0', {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
    })

    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
            } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
            }

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            if (document.body.clientWidth <= 1060) {
                                let scale = document.body.clientWidth / 1080
                                $('#root').css('zoom', scale)
                            } else {
                                const scale = document.body.clientWidth / 1920
                                $('#root').css('zoom', scale)
                            }
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        if (dataSrc) {
                            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                        }
                        lazyLoadObserver.unobserve(image) // 停止观察该图片
                    }
                })
            },
                config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image) // 开始观察每个图片
            })
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach(subArray => {
                    subArray.forEach(url => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                // 处理一维数组
                imageArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()

        let imgList = [
            'https://cdn.shopify.com/s/files/1/0575/6272/6451/files/20260401-p1.png',
            'https://cdn.shopify.com/s/files/1/0575/6272/6451/files/20260401-p2.png',
            'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/d997391c61cd840e3d506efe47bc78f7.png?v=1775187183',

            'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/4bf60a0e10cad33380c3b330d3fdf156.png?v=1775187183',
            'https://cdn.shopify.com/s/files/1/0792/4272/3633/files/04399b000ff2a287b372edd7cb872230.png?v=1775187183',
            'https://cdn.shopify.com/s/files/1/0575/6272/6451/files/20260427__img_3.png?v=1777286228',
            'https://cdn.shopify.com/s/files/1/0575/6272/6451/files/20260401-p4.png',
        ]
        // 预加载所有图片
        preloadImages(imgList)

        function updateMainImage() {
            let index1 = $('#sp-opt-group1 .sp-option.active').index()
             let index2 = $('#sp-opt-group2 .sp-option.active').index()
            // let index2 = 0
            if (index1) {
                $(".sp-free-img").show()
            }else {
                $(".sp-free-img").hide()
            }
            $('.sp-img-p').attr('src', imgList[index2])
            const text = ['X2', 'X3']
            // if (index2) {
            //     $(".sp-prod-size").show().text(text[index2 - 1])
            // } else {
            //     $(".sp-prod-size").hide()
            // }
        }

        $('.sp-option').click(function () {
            $(this).siblings().removeClass('active')
            $(this).addClass('active')
            $(this).parent().prev().find('span').text($(this).text())
            // $('.sp-color-title').text($(this).text())
            updateMainImage()
        })

        // 初始化图片
        updateMainImage()

        // IOS字体多了间距的处理
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent)

        if (!isAndroid && !isIOS && !isPC) {
            $('.sp_system').css('letter-spacing', '-4px')
        }

        // 平整的左右滑动轮播
        carouselSwiper = new Swiper('#carousel .swiper', {
            grabCursor: true,
            centeredSlides: false,
            slidesPerView: 'auto',
            spaceBetween: 20, // 卡片之间的间距
            loop: true,
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                reverseDirection: false,
            },
            freeMode: {
                enabled: true,
                momentum: false,
            },
            speed: 5000,
            on: {
                touchEnd: function () {
                    // 触摸结束后，强制重启自动播放
                    var swiper = this
                    setTimeout(function () {
                        swiper.autoplay.stop()
                        swiper.autoplay.start()
                    }, 50)
                },
                slideChangeTransitionEnd: function () {
                    // 滑动过渡结束后，确保自动播放继续
                    var swiper = this
                    setTimeout(function () {
                        if (!swiper.autoplay.running) {
                            swiper.autoplay.stop()
                            swiper.autoplay.start()
                        }
                    }, 50)
                },
            },
        })

        // 定期检查并重启自动播放（作为备用方案）
        setInterval(function () {
            if (carouselSwiper && !carouselSwiper.autoplay.running) {
                carouselSwiper.autoplay.start()
            }
        }, 1000)
    }

    mainRender()

    // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
    function handleShoppingLinkClick(event) {
        const link = event.target.closest('a[href="#shopping"]')
        if (!link) return

        event.preventDefault()

        const targetElement = document.getElementById('shopping')
        if (targetElement) {
            const offsetTop = targetElement.offsetTop
            let sptop = document.body.clientWidth <= 1080 ? 110 : 140
            let zoomValue = parseFloat($('div#root').css('zoom')) || 1
            const scrollTop = offsetTop * zoomValue - sptop * zoomValue

            window.scrollTo({
                top: scrollTop,
                behavior: 'smooth',
            })

            setTimeout(() => {
                if (
                    window.pageYOffset === 0 ||
                    Math.abs(window.pageYOffset - scrollTop) > 100
                ) {
                    $('html, body').animate(
                        {
                            scrollTop: scrollTop,
                        },
                        800
                    )
                }
            }, 100)
        }
    }

    // 使用事件委托在document上监听所有点击
    document.addEventListener('click', handleShoppingLinkClick)

    let sp_price1 = 18.99
    let sp_price2 = 47.5

    function calcTotal(price, num) {
        let result = Number(price) * Number(num)
        return result.toFixed(2)
    }
    $('.sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        changePrice()
    })
    $('.sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        changePrice()
    })

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span, div')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 给每个 span/div 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`
                            span.style.animationDelay = `${index * 0.1}s`

                            const i = span.querySelector('i')
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`
                                i.style.animationDelay = `${index * 0.1}s`
                            }
                        })

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`
                            paragraph.style.animationDelay = `${totalDelay}s`
                        }

                        observer.unobserve(gradually)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observer.observe(gradually)
    }

    // 菜单
    $('.sp-menu-btn').click(function (e) {
        $('.sp-menu-mask').show()
    })

    $('.sp-menu-mask').click(function (e) {
        $('.sp-menu-mask').hide()
    })

    function getZoomValue() {
        let zoom = $('div#root').css('zoom')
        return parseFloat(zoom) || 1
    }

    function handleScroll() {
        // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        // let zoomValue = getZoomValue();
        // let headerHeight = $(".header:visible").height() * zoomValue;
        // if (scrollTop > headerHeight) {
        //   $(".sp-pc .sp-header-top").addClass("sp-fixed");
        // } else {
        //   $(".sp-pc .sp-header-top").removeClass("sp-fixed");
        // }
    }

    // 初始检查
    handleScroll()

    // 监听多种滚动事件
    window.addEventListener('scroll', handleScroll, true)
    document.addEventListener('scroll', handleScroll, true)

    $(function () {
        // 判断是否为移动端
        function isMobile() {
            return document.body.clientWidth <= 1060
        }

        // 购物车加购动效
        $('.cart-btn').click(function () {
            $(this).children('img').addClass('on')
            if (isMobile()) {
                $('.sp-mobile .sp-cart .num').show()
                $('.sp-mobile .sp-cart').addClass('on')
                setTimeout(function () {
                    $('.sp-mobile .sp-cart').removeClass('on')
                }, 500)
            } else {
                $('.sp-pc .sp-header-top .sp-cart .num').show()
                $('.sp-pc .sp-header-top .sp-cart').addClass('on')
                setTimeout(function () {
                    $('.sp-pc .sp-header-top .sp-cart').removeClass('on')
                }, 500)
            }
            setTimeout(function () {
                $('.cart-btn').children('img').removeClass('on')
            }, 500)
        })

        let initNum = 0

        $('.product-part .cart-btn').click(function () {
            var data = {
                id: getCur().id,
                quantity: $('#calcNumber').val(),
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function () {
                    $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                        // $("#cardNum").html(result.item_count);
                        $('.cardNum').each(function () {
                            $(this).html(result.item_count)
                            $(this).removeClass('sp-gray')
                        })
                    })
                },
                dataType: 'json',
            })

            var imgs = $('.sp-img-p.active')

            imgs.each(function () {
                var $img = $(this)
                var flyer = $img[0].cloneNode(true)
                flyer.classList.add('sp_clone')

                $('.product-part').append(flyer)
                $(flyer).css({
                    width: $img[0].width,
                    height: $img[0].height,
                    background: '#e7e9ef',
                    position: 'fixed',
                    top: $img[0].offsetTop,
                    left: $img.offset().left,
                    'z-index': 99,
                })

                let finish, targetTop, targetLeft

                if (isMobile()) {
                    // 移动端：飞向底部固定按钮中的购物车
                    finish = $('.sp-btn-style2.sp-mobile .sp-cart')
                    if (finish.length > 0) {
                        targetTop = $('.sp-btn-style2')[0].offsetTop
                        targetLeft =
                            $('.sp-btn-style2 .sp-cart')[0].offsetLeft + finish.width() / 2
                    } else {
                        targetTop = 0
                        targetLeft = 0
                    }
                } else {
                    // PC端：飞向header中的购物车
                    finish = $('.sp-pc .sp-cart')
                    if (finish.length > 0) {
                        targetTop = finish[0].offsetTop + 20
                        targetLeft = finish[0].offsetLeft
                    } else {
                        targetTop = 0
                        targetLeft = 0
                    }
                }

                $(flyer).animate(
                    {
                        top: targetTop,
                        left: targetLeft,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    'linear',
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach()
                            }
                        )
                    }
                )
            })
        })
    })

    // 问答
    $('.q-row').click(function () {
        $(this).parent().toggleClass('sp-show')
    })

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName('sp-fade-box')
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll('.sp-ani')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`
                        })

                        observerAni.unobserve(gradually2)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually2)
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

        const observerAni = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`
                            span.style.animationDelay = `${index * 0.3 + 1}s`
                        })

                        observerAni.unobserve(gradually3)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observerAni.observe(gradually3)
    }
})
